import cx from 'clsx';
import * as React from 'react';

import { AnimationEffectType, TileAnimationDataType } from '@/types/gameTypes';

import styles from './GameTile.module.scss';

interface GameTileProps {
  stretchable?: boolean;
  attachAnimationStyles?: TileAnimationDataType;
}

const getAnimationStyle = (animation?: AnimationEffectType): string =>
  animation ? styles[animation] : '';

const GameTile = ({
  attachAnimationStyles,
  stretchable = false,
  children,
  ...rest
}: React.PropsWithChildren<GameTileProps>) => {
  return (
    <div
      className={cx([
        styles.container,
        stretchable ? styles.stretchable : styles.square,
        getAnimationStyle(attachAnimationStyles?.animationType),
      ])}
      {...rest}
    >
      {children}
    </div>
  );
};

export default GameTile;
